import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatCheckboxChange } from "@angular/material/checkbox";
import { Subject } from 'rxjs';

@Component({
  selector: 'app-select-all-button',
  templateUrl: './select-all-button.component.html',
  styleUrls: ['./select-all-button.component.scss']
})
export class SelectAllButtonComponent implements OnInit,OnDestroy {
  @Input() data:any = {};
  @Output() dataChange: EventEmitter<any> = new EventEmitter();
  master_checked: boolean = false;
  private destroy$ = new Subject<void>();
  
  constructor() { }

  ngOnInit(): void {
  }

  selectAll(event: MatCheckboxChange) {
    this.dataChange.emit(event);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
